import React from 'react';

import DocumentsContainer from '@totem/components/documents/report/documentsContainer';
import DocumentsLayout, {
  DocumentsExtra,
} from '@totem/components/documents/report/documentsLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const DocumentsPage = () => (
  <ContentLayout>
    <DocumentsContainer
      componentKey={'dashboard.documents'}
      defaultSort={{ field: 'document.createdAt', direction: 'descend' }}
    >
      <IBCard isCovered title="Document Repository" extra={<DocumentsExtra />}>
        <DocumentsLayout />
      </IBCard>
    </DocumentsContainer>
  </ContentLayout>
);

export default DocumentsPage;
